import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/distributor-groups/create',
    name: 'distributorGroupCreate',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-group/DistributorGroupCreateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_CREATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/distributor-groups/:groupId/edit',
    name: 'distributorGroupUpdate',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-group/DistributorGroupUpdateView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_UPDATE_PERMISSION'],
      menuSelected: 'networks'
    }
  },
  {
    path: '/distributor-groups/:groupId',
    name: 'distributorGroupDetail',
    component: () =>
      import(
        '@/views/restricted/distributor-networks/distributor-group/DistributorGroupDetailLayoutView.vue'
      ),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_DISTRIBUTOR_NETWORK_READ_PERMISSION'],
      menuSelected: 'networks'
    }
  }
]
